<template>
  <section class="gr-section">
    <div class="container">
      <div class="gr-head">
        <h2>অন্যান্য গাইডলাইন</h2>
        <p>আপনার প্রস্তুতি আরও এগিয়ে নিতে এই বিষয়গুলোও দেখে নিন</p>
      </div>

      <div class="gr-grid">
        <div
          v-for="g in others"
          :key="g.key"
          class="gr-card"
          @click="go(g)"
        >
          <div class="gr-card-img">
            <img :src="g.image" :alt="g.title" />
            <span class="gr-card-mark">{{ g.marks }}</span>
          </div>
          <div class="gr-card-body">
            <div class="gr-tags">
              <span class="gr-tag" v-for="t in g.tags.slice(0, 3)" :key="t">{{ t }}</span>
            </div>
            <h3>{{ g.title }}</h3>
            <p>{{ g.desc }}</p>
            <span class="gr-link">
              গাইডলাইন দেখুন
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M13.267 4.209a.75.75 0 0 0-1.06 1.06l5.58 5.58H3.75a.75.75 0 0 0 0 1.5h14.037l-5.58 5.58a.75.75 0 1 0 1.06 1.06l6.868-6.867a.75.75 0 0 0 0-1.062l-6.868-6.851z" fill="currentColor"/>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { guidelines } from "@/components/WelcomePages/guidelinesData";

export default {
  name: 'GuidelineRelated',
  props: {
    current: { type: String, required: true },
  },
  setup(props) {
    const router = useRouter();
    const others = computed(() => guidelines.filter(g => g.key !== props.current));
    const go = (g) => router.push({ name: g.route });
    return { others, go };
  },
};
</script>

<style scoped>
* { box-sizing: border-box; }

.gr-section { background: #f8fafc; padding: 56px 0; }

.gr-head { text-align: center; margin-bottom: 32px; }
.gr-head h2 {
  font-family: 'Noto Serif Bengali', serif;
  font-size: 1.4rem; font-weight: 800; color: #191B47;
  display: inline-block; border-bottom: 3px solid #0095FF; padding-bottom: 6px; margin: 0;
}
.gr-head p { color: #64748b; font-size: 0.88rem; margin: 12px 0 0; }

.gr-grid {
  width: 100%; max-width: 100%; min-width: 0;
  display: flex; gap: 20px;
  overflow-x: auto; overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  padding: 6px 4px 18px;
}
.gr-grid::-webkit-scrollbar { height: 6px; }
.gr-grid::-webkit-scrollbar-track { background: #e2e8f0; border-radius: 3px; }
.gr-grid::-webkit-scrollbar-thumb { background: #94a3b8; border-radius: 3px; }

.gr-card {
  flex: 0 0 320px; scroll-snap-align: start;
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 18px; overflow: hidden; cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
  display: flex; flex-direction: column;
}
@media (max-width: 560px) { .gr-card { flex-basis: 270px; } }
.gr-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 32px rgba(25, 27, 71, 0.12);
  border-color: #0095FF;
}

.gr-card-img { position: relative; overflow: hidden; }
.gr-card-img img { width: 100%; height: auto; display: block; }
.gr-card-mark {
  position: absolute; top: 12px; right: 12px;
  background: #191B47; color: #0095FF;
  font-size: 0.72rem; font-weight: 800;
  padding: 4px 12px; border-radius: 999px;
}

.gr-card-body { padding: 20px; flex: 1; display: flex; flex-direction: column; }
.gr-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 12px; }
.gr-tag {
  font-size: 0.68rem; font-weight: 600; color: #4f46e5;
  background: #eef2ff; border: 1px solid #c7d2fe;
  padding: 2px 8px; border-radius: 4px;
}
.gr-card-body h3 { font-size: 1rem; font-weight: 800; color: #191B47; margin: 0 0 8px; text-align: left; }
.gr-card-body p { font-size: 0.84rem; color: #64748b; line-height: 1.65; margin: 0 0 16px; text-align: left; flex: 1; }
.gr-link {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 0.82rem; font-weight: 700; color: #191B47; margin-top: auto;
}
</style>